import React from 'react';
const PRODUCT_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/wL6mcRFHhMPAPdYcwmY6iD/2a47878f-8893-420e-9038-0be0833cd1f5.webp';
export function ProductMockup() {
  return <div className="relative w-full max-w-5xl mx-auto mt-4 mb-2 md:mt-10 md:mb-4" data-id="element-206">
      <div className="absolute inset-0 bg-gold-500/10 blur-[100px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-207" />
      <img src={PRODUCT_IMAGE_URL} alt="The Complete Baseball Coaching System — Baseball Ready: System 365, including 6 volumes and 5 exclusive bonuses" className="relative z-10 w-full h-auto max-h-[38vh] md:max-h-none object-contain rounded-2xl shadow-2xl" loading="eager"
    // @ts-ignore - fetchPriority is a valid img attribute
    fetchpriority="high" decoding="async" data-id="element-208" />
    </div>;
}